import React from 'react'
import { Box } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'

const LoadingShipmentDetailsStatus = () => {
  return (
    <Box display='grid' p='24px' pb='0' height='443px' gridTemplateRows='max-content 1fr'>
      <Skeleton variant='rectangular' width='100%' height='240px' />
      <Box display='grid' mt='24px' gridTemplateRows='1fr 1fr 1fr 1fr' gap='8px'>
        <Skeleton variant='rectangular' width='100%' height='100%' />
        <Skeleton variant='rectangular' width='80%' height='100%' />
        <Skeleton variant='rectangular' width='50%' height='100%' />
        <Skeleton variant='rectangular' width='70%' height='100%' />
      </Box>
    </Box>
  )
}

export default LoadingShipmentDetailsStatus
